export default function ($scope,authenticationService,reminderService,$location,ngDialog,$window,AUTH_EVENTS,$rootScope) {
  $scope.credentials = { email: "", password: "", remember_me: "" };
  $scope.created_at = "";
  $scope.sent = "";
  $scope.isSending = false;
  $scope.isProcess = false;

  $scope.login = function () {
    $scope.flash = " ";
    $scope.sent = " ";
    $scope.created_at = "";
    $scope.isSending = !$scope.isSending;
    $scope.credentials.email = $scope.credentials.email.toLowerCase();
    $scope.credentials.email = $scope.removeSpace($scope.credentials.email);
    authenticationService.login($scope.credentials).then(function (user) {
      $scope.isSending = !$scope.isSending;
      $rootScope.$broadcast(AUTH_EVENTS.loginSuccess,user.data);
      $rootScope.$broadcast(AUTH_EVENTS.platformAuthentication);
      ngDialog.closeAll();
      if($location.path() == '/prime') {
        $location.path('/official-plan');
        $rootScope.$broadcast('getSidebar');
      }
    }, function (data) {
      $scope.isSending = !$scope.isSending;
      if(data.data.flash){
        $scope.flash = data.data.flash;
        if($scope.flash == 'trial'){
          ngDialog.open({
            templateUrl:'templates/trial-ended.tpl.html',
            className:'ngdialog-theme-plain'
          });
        }else if($scope.flash == 'sub'){
          ngDialog.open({
            templateUrl:'templates/sub-ended.tpl.html',
            className:'ngdialog-theme-plain'
          });
        }
      }else if(data.data.activate){
        $scope.created_at = data.data.activate;
        ngDialog.open({
          templateUrl:'templates/activation-required.tpl.html',
          className:'ngdialog-theme-plain',
          scope: $scope
        });
      }
    });
  };

  //Resend user their activation link
  $scope.sendActivation = function(){
    $scope.isProcess = !$scope.isProcess;
    $scope.sent = false;
    $scope.flash = false;
    reminderService.sendactivation($scope.credentials).success(function (data){
      $scope.isProcess = !$scope.isProcess;
      $scope.sent = data.sent;
    }).error(function (data){
      $scope.isProcess = !$scope.isProcess;
      $scope.flash = data.flash;
    });
  };

  $scope.removeSpace =  function (str) {
    str = str.replace(/^\s+/, '');
    for (var i = str.length - 1; i >= 0; i--) {
      if (/\S/.test(str.charAt(i))) {
        str = str.substring(0, i + 1);
        break;
      }
    }
    return str;
  };

  //Launch Register
  $scope.launchRequest = function () {
    $rootScope.request = ngDialog.open({
      templateUrl:'templates/tmp_register.tpl.html',
      controller:'registerCtrl',
      className: 'ngdialog-theme-plain'
    });
  };

  //Launch Forgot
  $scope.launchForgot = function () {
    $scope.forgotDialog = ngDialog.open({
      templateUrl:'templates/forgotpassword.tpl.html',
      controller:'ForgotCtrl',
      className:'ngdialog-theme-default'
    });
  };
};



// WEBPACK FOOTER //
// ./client/controllers/Login.js